import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Typography,
  TextField,
  FormControl,
  Button,
  Rating,
  Autocomplete,
  Radio,
  RadioGroup,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import styles from "../../styles/common/filterAccordion.module.css";
import React, { useEffect, useState } from "react";
import { useAllChallengeNames, useAllFundNames } from "../../lib/hooks";
import { rangeToString } from "../../lib/util";

interface Props {
  formDataHandler: Function;
  removeChallengeProposal: Function;
  less?: boolean;
}
const max: number = 999999999999999999;

const ProposalFilter = (props: Props) => {
  const [fund_id, setFund_id] = useState<any[]>([]);
  const [challenge_id, setChallenge_id] = useState<any[]>([]);

  const {
    allChallengeNames,
    loading: allChallengeNameLoading,
    error: allChallengeNameError,
  } = useAllChallengeNames();

  let {
    loading: fundNameLoading,
    allFundNames,
    error: fundNamError,
  } = useAllFundNames();

  let challenge_dropDownOption =
    !fundNameLoading &&
    !allChallengeNameLoading &&
    allChallengeNameError === null &&
    fundNamError === null
      ? fund_id.length > 0
        ? allChallengeNames
            .filter((item) =>
              fund_id.map((item) => item.id).includes(item.fund_id)
            )
            .map((item) => {
              return {
                label: `${item.fund_name}:${item.challenge_name}`,
                id: item.challenge_id,
              };
            })
        : allChallengeNames.map((item) => {
            return {
              label: `${item.fund_name}:${item.challenge_name}`,
              id: item.challenge_id,
            };
          })
      : [];

  useEffect(() => {
    if (challenge_id.length > 0) {
      let newArr = challenge_id.filter((challenge) =>
        fund_id
          .map((item) => item.id)
          .includes(
            allChallengeNames.filter(
              (allChallenge) => allChallenge.challenge_id === challenge.id
            )[0]?.fund_id
          )
      );
      setChallenge_id(newArr);
    }
    //eslint-disable-next-line
  }, [fund_id.length]);

  // handle fund status change
  const [fundStatus, setFundStatus] = useState<any>("All");
  const [isChallengeProposal, setIsChallengeProposal] = useState<any>("All");

  const handleFundStatusChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setFundStatus((event.target as HTMLInputElement).value);
  };

  const handleChallengeSettingChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsChallengeProposal((event.target as HTMLInputElement).value);
  };

  const [rating, setRating] = useState<number>(1);
  const [requestedMin, setRequestedMin] = useState<any>(0);
  const [requestedMax, setRequestedMax] = useState<any>(max);
  const [requestedAmount, setRequestedAmount] = useState<string>(
    "[0," + max.toString() + "]"
  );
  const requestedHandler = (event: React.FormEvent) => {
    event.preventDefault();
    setRequestedAmount(rangeToString(requestedMin, requestedMax));
  };

  useEffect(() => {
    let formData: any = {
      challenge_id:
        challenge_id.length === 0 ? "All" : challenge_id.map((item) => item.id),
      rating: rating,
      amount_requested: requestedAmount,
      funded_status: fundStatus,
      fund_id: fund_id.length === 0 ? "All" : fund_id.map((item) => item.id),
    };

    if (isChallengeProposal === "All") {
      props.removeChallengeProposal();
      props.formDataHandler(formData);
    } else {
      formData.is_challenge_proposal = isChallengeProposal;
      props.formDataHandler(formData);
    }
    //eslint-disable-next-line
  }, [
    rating,
    isChallengeProposal,
    requestedAmount,
    fundStatus,
    challenge_id,
    fund_id,
  ]);

  return (
    <div className={styles.div}>
      <Grid container className={styles.filterGrid}>
        <Grid item>
          <Typography variant="h5">Filter</Typography>
        </Grid>
      </Grid>

      {!props.less && (
        <>
          <Accordion className={styles.accordion} elevation={0}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Fund</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Autocomplete
                // autoComplete
                multiple={true}
                id="combo-box-demo"
                options={
                  !fundNameLoading && fundNamError === null
                    ? allFundNames.map((item) => {
                        return {
                          label: item.fund_name,
                          id: item.fund_id,
                        };
                      })
                    : []
                }
                size={"small"}
                onChange={(event: any, newValue: any[] | null) => {
                  setFund_id(newValue as any[]);
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={fund_id}
                renderInput={(params) => (
                  <TextField {...params} label="Select Funds" />
                )}
              />
            </AccordionDetails>
          </Accordion>

          <Accordion className={styles.accordion} elevation={0}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Challenge</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Autocomplete
                // autoComplete
                multiple={true}
                id="combo-box-demo"
                options={challenge_dropDownOption}
                size={"small"}
                onChange={(event: any, newValue: any[] | null) => {
                  setChallenge_id(newValue as any[]);
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                // disableClearable
                value={challenge_id}
                renderInput={(params) => (
                  <TextField {...params} label="Select Challenges" />
                )}
              />
            </AccordionDetails>
          </Accordion>
        </>
      )}

      <Accordion className={styles.accordion} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Status</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="All"
              name="radio-buttons-group"
              onChange={handleFundStatusChange}
            >
              <FormControlLabel value="All" control={<Radio />} label="All" />
              <FormControlLabel
                value="True"
                control={<Radio />}
                label="Funded"
              />
              <FormControlLabel
                value="False"
                control={<Radio />}
                label="Not Funded"
              />
            </RadioGroup>
          </FormControl>
        </AccordionDetails>
      </Accordion>

      <Accordion className={styles.accordion} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Amount Requested</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={requestedHandler}>
            <FormControl
              size="small"
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "5px",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <TextField
                type="number"
                id="outlined-basic"
                label="Min"
                variant="outlined"
                size="small"
                name="min"
                onChange={(event) => {
                  event.target.value
                    ? setRequestedMin(event.target.value)
                    : setRequestedMin(0);
                }}
              />
              <TextField
                type="number"
                id="outlined-basic"
                label="Max"
                variant="outlined"
                size="small"
                name="max"
                onChange={(event) => {
                  event.target.value
                    ? setRequestedMax(event.target.value)
                    : setRequestedMax(max);
                }}
              />
              <Button variant="contained" type="submit">
                Submit
              </Button>
            </FormControl>
          </form>
        </AccordionDetails>
      </Accordion>

      <Accordion className={styles.accordion} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Rating</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Rating
            name="simple-controlled"
            value={rating ? rating : 0}
            onChange={(event, newVal) => setRating(newVal as number)}
          />
        </AccordionDetails>
      </Accordion>

      {!props.less && (
        <Accordion className={styles.accordion} elevation={0}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Challenge Setting</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="All"
                name="radio-buttons-group"
                onChange={handleChallengeSettingChange}
              >
                <FormControlLabel value="All" control={<Radio />} label="All" />
                <FormControlLabel
                  value="True"
                  control={<Radio />}
                  label="Challenge Proposal"
                />
                <FormControlLabel
                  value="False"
                  control={<Radio />}
                  label="Non-Challenge Proposal"
                />
              </RadioGroup>
            </FormControl>
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  );
};

export default ProposalFilter;
